import { Box } from '@mui/material'
import { Outlet } from 'react-router-dom'

const PublicLayout = () => {
  return (
    <div className="main">
      <Box className="content" pt="4rem">
        <Box
          position="absolute"
          top={'50%'}
          left={'50%'}
          sx={{
            transform: 'translate(-50%, -50%)',
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </div>
  )
}

export default PublicLayout
